"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var saveToDisk_1 = require("../../../common/helpers/saveToDisk");
var AdminAgendaController = /** @class */ (function () {
    function AdminAgendaController($rootScope, UserService, $state, $stateParams, CalendarModel, DrivesFilterService, TimeoffRequestsModel, FlashService, $window, CalendarService, VueStoreFactory, AdminCreateDriveService, UsersModel) {
        this.UserService = UserService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.VueStoreFactory = VueStoreFactory;
        this.CalendarModel = CalendarModel;
        this.DrivesFilterService = DrivesFilterService;
        this.TimeoffRequestsModel = TimeoffRequestsModel;
        this.FlashService = FlashService;
        this.$window = $window;
        this.CalendarService = CalendarService;
        this.AdminCreateDriveService = AdminCreateDriveService;
        this.UsersModel = UsersModel;
        this.printingRmv = false;
        this.modalShown = false; //rto modal
        this.rto = {};
        this.rtoIndex = null;
        this.currentUser = UserService.getCurrentUser();
        this.rmvSheetsAvailable =
            ((this.currentUser.school || {}).address || {}).state === "MA";
        this.date = $stateParams.date;
        this.sessionsUpdated = this.sessionsUpdated.bind(this);
        this.handleAgendaResults = this.handleAgendaResults.bind(this);
        this.openRTOModal = this.openRTOModal.bind(this);
        this.closeRTOModal = this.closeRTOModal.bind(this);
        this.deleteRTODay = this.deleteRTODay.bind(this);
        this.deleteRTO = this.deleteRTO.bind(this);
        this.visitCourse = this.visitCourse.bind(this);
        this.isToday = this.isToday.bind(this);
        this.selectedInstructor = this.selectedInstructor.bind(this);
        this.printRmvInCarSheet = this.printRmvInCarSheet.bind(this);
        this.DrivesFilterService.setDate(this.date);
        this.filterQuery = DrivesFilterService.getFilterParameters();
        this.filterQuery.statusIsnt = "Inactive - Scheduling Conflict";
        if (!this.filterQuery.status) {
            this.filterQuery.status = "all";
        }
        this.items = [];
        this.messengerUsers = [];
        this.CalendarModel.getAdminAgenda(this.filterQuery).then(this.handleAgendaResults);
        $rootScope.$on("UPDATE_AGENDA", this.sessionsUpdated);
    }
    AdminAgendaController.prototype.createLessonOnDate = function () {
        this.AdminCreateDriveService.setDate((0, time_1.dateStringToDate)(this.date));
        this.$state.go("drivecoach.admin.drives.create");
    };
    /**
     * The RMV in-car sheet is generated per instructor + date, so it is only
     * offered when the agenda filter has a single instructor selected.
     */
    AdminAgendaController.prototype.selectedInstructor = function () {
        var instructor = this.DrivesFilterService.getFilterParameters().instructor;
        return instructor && instructor.id ? instructor : null;
    };
    AdminAgendaController.prototype.printRmvInCarSheet = function () {
        var _this = this;
        var instructor = this.selectedInstructor();
        if (instructor === null) {
            return;
        }
        this.printingRmv = true;
        this.UsersModel.getInstructorRmvInCarSheet(instructor.id, {
            date: this.date,
        })
            .then(function (response) {
            _this.printingRmv = false;
            (0, saveToDisk_1.saveToDisk)(response.file.url, response.file.name);
        })
            .catch(function () {
            _this.printingRmv = false;
        });
    };
    AdminAgendaController.prototype.setSelectedUsers = function () {
        this.messengerUsers = this.items
            .filter(function (item) {
            // Type guard to ensure item is a drive with student
            var driveItem = item;
            return driveItem.selected === true && !!driveItem.student;
        })
            .map(function (item) {
            if (item.student) {
                item.student.name =
                    item.student.firstname + " " + item.student.lastname;
                return item.student;
            }
            return null;
        })
            .filter(function (student) { return student !== null; });
    };
    AdminAgendaController.prototype.setSectorPopover = function (zone, sectors) {
        this.zone = zone;
        this.sectors = sectors.filter(function (sector) {
            return parseInt(sector.zone_id, 10) === parseInt(zone.id, 10);
        });
    };
    AdminAgendaController.prototype.next = function () {
        this.$state.go("drivecoach.admin.agenda", {
            date: (0, time_1.toYMD)((0, time_1.addDays)((0, time_1.dateStringToDate)(this.date), 1)),
        });
    };
    AdminAgendaController.prototype.prev = function () {
        this.$state.go("drivecoach.admin.agenda", {
            date: (0, time_1.toYMD)((0, time_1.subtractDays)((0, time_1.dateStringToDate)(this.date), 1)),
        });
    };
    AdminAgendaController.prototype.today = function () {
        this.$state.go("drivecoach.admin.agenda", {
            date: (0, time_1.toYMD)(new Date()),
        });
    };
    AdminAgendaController.prototype.isToday = function () {
        var today = new Date();
        var compareDate = (0, time_1.dateStringToDate)(this.date);
        return (today.getFullYear() === compareDate.getFullYear() &&
            today.getMonth() === compareDate.getMonth() &&
            today.getDate() === compareDate.getDate());
    };
    AdminAgendaController.prototype.isDriveSession = function (item) {
        return item.type === "Drive Session";
    };
    AdminAgendaController.prototype.isCourse = function (item) {
        return item.type === "Course";
    };
    AdminAgendaController.prototype.isEvent = function (item) {
        return item.type === "Event";
    };
    AdminAgendaController.prototype.isRTO = function (item) {
        return item.typeDisplay === "RTO";
    };
    AdminAgendaController.prototype.openRTOModal = function (rto, index) {
        this.modalShown = true;
        this.rto = rto;
        this.rtoIndex = index;
    };
    AdminAgendaController.prototype.closeRTOModal = function () {
        this.modalShown = false;
        this.rto = {};
        this.rtoIndex = null;
    };
    AdminAgendaController.prototype.visitCourse = function (course) {
        var data = {
            id: course.id,
            class_id: course.class_id,
            date: new Date(course.date + " 00:00:00").toLocaleDateString(),
            start: course.startTime,
            end: course.endTime,
        };
        this.VueStoreFactory.dispatch("SET_VIEW_COURSE", data);
        this.$state.go("drivecoach.admin.courses.view", { courseId: course.id });
    };
    AdminAgendaController.prototype.deleteRTODay = function (rto, index) {
        var _this = this;
        var confirmDelete = this.$window.confirm("Are you sure you want to delete this day in this request? It cannot be undone.");
        if (!confirmDelete) {
            return;
        }
        rto.deleteDay = this.date;
        this.TimeoffRequestsModel.deleteDay(rto).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.items.splice(index, 1);
            _this.closeRTOModal();
            // $state.go('drivecoach.admin.calendar', {}, {'reload': true});
        });
    };
    AdminAgendaController.prototype.deleteRTO = function (rto, index) {
        var _this = this;
        var confirmDelete = this.$window.confirm("Are you sure you want to delete this time off request? It cannot be undone.");
        if (!confirmDelete) {
            return;
        }
        this.TimeoffRequestsModel.delete(rto).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.items.splice(index, 1);
            _this.closeRTOModal();
            // this.$state.go('drivecoach.admin.calendar', {}, {'reload': true});
        });
    };
    AdminAgendaController.prototype.sessionsUpdated = function () {
        // cal analog is this.CalendarService.getCalendarItems();
        this.items = this.CalendarService.getAgendaItems();
    };
    AdminAgendaController.prototype.handleAgendaResults = function (response) {
        this.DrivesFilterService.setDate(this.date);
        this.items = this.CalendarService.processAgenda(response);
    };
    return AdminAgendaController;
}());
AdminAgendaController.$inject = [
    "$rootScope",
    "UserService",
    "$state",
    "$stateParams",
    "CalendarModel",
    "DrivesFilterService",
    "TimeoffRequestsModel",
    "FlashService",
    "$window",
    "CalendarService",
    "VueStoreFactory",
    "AdminCreateDriveService",
    "UsersModel",
];
exports.default = AdminAgendaController;
